import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ActivityIndicator, FlatList, Image, ImageBackground, ScrollView, TextInput, View } from 'react-native';
import { useDispatch, useSelector } from "react-redux"
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { event_getLeagues } from '../../store/actionsv1/events';
import { market_getBestAvailable, market_getMarkets } from '../../store/actionsv1/markets';
import { EventProps, LeagueProps, TournamentProps } from '../../store/types/sr_svc';
import LeagueLozenge from './components/LeagueLozenge';
import { EventOrderStatProps } from '../../store/types/mk_svc';
import { Icon } from 'react-native-elements';
import { event_searchEventsByTeam } from './helpers/events';
import SuggestedMarkets from './components/SuggestedMarkets/SuggestedMarkets';
import StarredFiltersCard from './components/StarredFiltersCard';
import { V1_HIDE_ALERT, V1_UPDATE_DEFAULT_LINES_VISIBLE } from '../../store/actionsv1/types';
import TournamentCard from './components/TournamentCard2';
import ALaCartePremium from '../../globalComponents/ALaCartePremium';
import MatchMarketCard from './components/MatchMarketCard';
import { Helmet } from 'react-helmet-async';
import { AdServer, BEEventApi } from 'be-components';
import TeamEventHolder from '../../Componentsv1/TeamEventHolder';
import { engage_getPublicEngagements } from '../../store/actionsv1/comps';
import TournamentHolder from '../../Componentsv1/TournamentHolder';
const sumByProperty = (arr, prop) => arr.reduce((acc, obj) => acc + parseInt(obj[prop]), 0);


const EventsScreen = ({ navigation }:any) => {
    const [ screenSize, setScreenSize ] = useState({ height: 800, width: 350 })
    const [ search, setSearch ] = useState({ visible:false, search_value: '' })
    const [ eventsExtended, setEventsExtended ] = useState();
    const [ loaded, setLoaded ] = useState(false);
    const dispatch = useDispatch()
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const default_lines = useSelector((state:any) => state.auth.default_lines, (left, right) => left == right);
    const leagues = useSelector((state:any) => state.event.leagues, (left, right) => left?.length === right?.length)
    const events_dict:{ [key:string]:EventProps } = useSelector((state:any) => state.event.events, (left, right) => left == right);
    const events = Object.values(events_dict)
    const hidden_alerts:string[] = useSelector((state:any) => state.auth.hidden_alerts, (left, right) => left.length == right.length);
    let show_external_price_prompt = true
    if(hidden_alerts && hidden_alerts.length > 0){
        let hide = hidden_alerts.find(a => a == 'quick_e_p_2')
        if(hide){ show_external_price_prompt = false }
    }
    const tournaments_dict:{ [key:string]:TournamentProps } = useSelector((state:any) => state.event.tournaments, (left, right) => left == right);
    const tournaments = Object.values(tournaments_dict)
    const order_stats_dict:{ [key:string]:EventOrderStatProps[] } = useSelector((state:any) => state.market.order_stats, (left, right) => left == right)
    const sorted_keys = useMemo(() => {
        return Object.keys(order_stats_dict).sort((keyA, keyB) => {
            const sumA = sumByProperty(order_stats_dict[keyA], 'open_order_amount');
            const sumB = sumByProperty(order_stats_dict[keyB], 'open_order_amount');
            return sumB - sumA; // Sort in descending order
        });

    },[order_stats_dict])


    let filtered_keys = eventsExtended ? sorted_keys.slice(0,25) : sorted_keys.slice(0,5)
    if(search.visible && search.search_value !== ''){
        filtered_keys = event_searchEventsByTeam(search.search_value, events, tournaments)
    }

    useEffect(() => {
        loadServerData()
    },[])


    const loadServerData = async() => {
        await dispatch(event_getLeagues());
        await dispatch(market_getBestAvailable());
        await dispatch(engage_getPublicEngagements());
        await dispatch(market_getMarkets());
        setLoaded(true);
    }


    const handleLeaguePress = (league:LeagueProps) => {
        navigation.push('League', { league_id: league.league_id })
    }

    const renderLeagues = (data:{item:LeagueProps, index:number}) => {
        return (
            <View style={{ marginTop:5, marginBottom:5 }}>
                <LeagueLozenge league={data.item} onSelect={(league) => handleLeaguePress(league)}/>
            </View>
        )
    }

    const renderContests = useCallback((data: { item:string, index:number }) => {
        let split_key = data.item.split(':')
        switch(split_key[0]){
            case 'team':
                return (
                    <View style={{ margin:1 }}>
                        <TeamEventHolder
                            event_id={split_key[1]}
                            navigation={navigation}
                            expanded={data.index == 0 ? true : false}
                        />
                        {(data.index > 0 && data.index % 5 == 0) || data.index == filtered_keys.length -1 ?
                        <AdServer
                            placement='events_feed'
                            ad_type='discover'
                            device_width={app_size.width}
                            role={player?.type}
                            onViewAd={(e) => BEEventApi.saveEvent(e)}
                            onClickAd={(e) => BEEventApi.saveEvent(e)}
                        />
                        :<></>}
                    </View>
                )
            case 'tournament':
                return (
                    <View style={{ margin:1 }}>
                        <TournamentHolder
                            tournament_id={split_key[1]}
                            navigation={navigation}
                        />
                        {(data.index > 0 && data.index % 5 == 0) || data.index == filtered_keys.length -1 ?
                        <AdServer
                            placement='events_feed'
                            ad_type='discover'
                            device_width={app_size.width}
                            role={player?.type}
                            onViewAd={(e) => BEEventApi.saveEvent(e)}
                            onClickAd={(e) => BEEventApi.saveEvent(e)}
                        />
                        :<></>}
                    </View>
                )
            default: return <></>
        }
    }, [])

    const renderComponents = (data:{item:string, index:number}) => {
        switch(data.item){
            case 'leagues':
                return (
                    <View nativeID='leagues' style={{ backgroundColor:Colors.shades.shade100, flexDirection:'row' }}>
                        <TouchableOpacity style={{ backgroundColor:Colors.shades.white, justifyContent:'center', alignItems:'center', paddingRight:15, paddingLeft:15 }} onPress={() => setSearch({ visible:!search.visible, search_value: '' })}>
                            <Icon name={search.visible?'x':'search'} type='feather' size={18} color={search.visible?Colors.utility.error:Colors.brand.midnight}/>
                        </TouchableOpacity>
                        {!search.visible ?
                        <FlatList data={leagues} renderItem={renderLeagues} keyExtractor={(item) => item.league_id.toString()} horizontal showsHorizontalScrollIndicator={false}/>
                        :
                        <TextInput 
                            style={{ margin:5, borderRadius:100, padding:15, backgroundColor:Colors.shades.white, flex:1, fontSize:14, color:Colors.brand.midnight }} 
                            value={search.search_value} 
                            placeholder='Search teams, tournaments, etc...'
                            onChangeText={(text) => setSearch({ ...search, search_value: text })}
                            />
                        }
                    </View>
                )
            case 'hot':
                return (
                    <View nativeID='popular_player_markets'>                    
                        <SuggestedMarkets navigation={navigation}/>
                    </View>
                )
            case 'bet_match':
                return (
                    <View nativeID='player_filters'>
                        <StarredFiltersCard
                            onManage={() => navigation.push('PlayerFilters')}
                            onFilterSelect={(pf) => navigation.push('BetMatch', { player_filter_id: pf.player_filter_id })}
                        />
                    </View>
                )
            case 'popular':
                return (
                    <View>
                    {sorted_keys.length > 0 ?
                        <View>
                            <View style={{ backgroundColor:Colors.shades.shade100, flexDirection:'row', alignItems:'center', justifyContent:'space-between' }}>
                                <ImageBackground style={{ flexDirection:'row', width:screenSize.width*0.75 }} source={{ uri: require('../../assets/images/diagnal_header.png') }}
                                resizeMode='cover'>
                                    <Text size={16} weight='semibold' color={Colors.shades.white} style={{margin:15}}>Popular Markets</Text>
                                </ImageBackground>
                                <TouchableOpacity style={{ padding:5, paddingRight:10, justifyContent:'center', alignItems:'center' }}
                                onPress={() => dispatch({ type:V1_UPDATE_DEFAULT_LINES_VISIBLE, default_lines_visible: true })}>
                                    <Text style={{ marginBottom:2 }} size={12} color={Colors.brand.electric} weight='regular'>Showing</Text>
                                    {default_lines == 'best_available' ?
                                        <Text size={12} color={Colors.brand.electric} weight='semibold'>Best Available</Text>
                                    :
                                        <Text size={12} color={Colors.brand.electric} weight='semibold'>Last Trade</Text>
                                    }
                                </TouchableOpacity>
                            </View>
                        </View>
                        :<></>}
                        <ALaCartePremium identifier='order_grades'/>
                        <View nativeID='active_events'>
                            <FlatList 
                                key={'active_events'}
                                data={filtered_keys}
                                maxToRenderPerBatch={10}
                                windowSize={50}
                                renderItem={renderContests} 
                                keyExtractor={(item, index) => `${item}:${index}`}/>
                        </View>
                        <TouchableOpacity style={{margin:20, padding:10, backgroundColor:Colors.shades.shade100, borderRadius:100}} onPress={() => setEventsExtended(!eventsExtended)}>
                            <Text size={14} color={Colors.brand.electric} weight='semibold' textAlign='center'>{eventsExtended?'See Less':'See More'}</Text>
                        </TouchableOpacity>
                    </View>
                )
            default: return <></>
        }
    }

    const components = ['leagues','hot','bet_match','popular']

    if(!loaded){
        return (
            <View style={{ padding:10, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight}/>
            </View>
        )
    }
    
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }} onLayout={(ev) => {
            const { height, width } = ev.nativeEvent.layout;
            setScreenSize({ height, width })
        }}>
            <Helmet>
                <title>BettorEdge Sports Betting Markets</title>
                <meta property='og:description' content='Bet against other users and not the house on your favorite sporting events' />
            </Helmet>
            <FlatList
                key={'market_components'}
                data={components}
                renderItem={renderComponents}
                keyExtractor={(item) => item}
            /> 
            {show_external_price_prompt ?
            <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.shade600, padding:10 }}>
                <Icon name='alert-circle' type='feather' color={Colors.brand.midnight} size={20} />
                <View style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text size={12} color={Colors.brand.midnight} weight='bold'>Did you know!</Text>
                    <Text style={{ marginTop:3 }} size={12} color={Colors.brand.midnight}>Hold down (long press) a market button above to quickly see external prices.</Text>
                </View>
                <TouchableOpacity onPress={() =>  dispatch({ type: V1_HIDE_ALERT, app_alert_id: 'quick_e_p_2' })}>
                    <Icon name='x' type='feather' color={Colors.utility.error} size={20} />
                </TouchableOpacity>
            </View>
            :<></>}
        </View>
    )
}


export default EventsScreen